import { css } from '@emotion/react';

import { SCROLL_DOWN, SCROLL_UP } from '../../const';
import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();

  return {
    quickLinks: (
      currentPage,
      divAnimation,
      scrollDirection,
      position,
      isDesktop,
      isIpad,
      isMobile,
      isSmallMobile,
      MQtoHideQuickLinks
    ) => css`
      max-width: 311px !important;
      position: absolute;
      padding-left: 0px !important;
      padding-top: 0px !important;
      cursor: pointer;
      margin-top: calc(100% - -76%);
      margin-left: calc(100% - 92%) !important;
      border-radius: 8px;
      background-image: none !important;
      z-index: 10;
      position: absolute;
      box-shadow: 0px 1px 11px rgba(1, 30, 65, 0.07),
              0px 4px 20px rgba(1, 30, 65, 0.14);
      

      @media (min-width: 577px) and (max-width: 758px) {
        margin-left: calc(100% - 55%) !important;
        margin-top: calc(100% - 45%);
      }

      &:focus{
        border: 2px solid ${colors.skip_yellow};
        outline: none;
      }

      ${
        MQtoHideQuickLinks &&
        (currentPage === 'homepage' ||
          currentPage === 'clubpage' ||
          currentPage === 'teampage') &&
        css`
          display: none;
        `
      }

      ${
        isMobile &&
        currentPage === 'homepage' &&
        css`
          margin-top: 700px;
          margin-left: calc(100% - 89%) !important;
        `
      }
      ${
        isMobile &&
        currentPage !== 'homepage' &&
        css`
          margin-top: 397px;
          margin-left: calc(100% - 46%) !important;
        `
      }

      ${
        isSmallMobile &&
        currentPage === 'homepage' &&
        css`
          margin-top: 667px !important;
        `
      }
      ${
        isSmallMobile &&
        currentPage !== 'homepage' &&
        css`
          margin-top: 407px;
        `
      }

      ${
        isDesktop &&
        currentPage === 'homepage' &&
        css`
          margin-top: calc(100% - 65%) !important;
          margin-left: calc(100% - 30.85%) !important;
        `
      }   
      ${
        isDesktop &&
        currentPage === 'teampage' &&
        css`
          margin-top: calc(100% - 65%) !important;
          margin-left: calc(100% - 35%) !important;
        `
      }   
      ${
        isDesktop &&
        currentPage === 'clubpage' &&
        css`
          margin-top: calc(100% - 57.5%) !important;
          margin-left: calc(100% - 35%) !important;
        `
      }

      ${
        isIpad &&
        currentPage === 'homepage' &&
        css`
          margin-left: calc(100% - 40%) !important;
          margin-top: calc(100% - 47%) !important;
        `
      }
      ${
        isIpad &&
        css`
          margin-left: calc(100% - 40%) !important;
          margin-top: calc(100% - 63%);
        `
      }
      ${
        currentPage === 'homepage' &&
        css`
          @media (min-device-width: 619px) and (max-device-width: 769px) {
            margin-left: calc(100% - 45%) !important;
            margin-top: calc(100% - 45%) !important;
          }
          @media (min-device-width: 770px) and (max-device-width: 821px) {
            margin-left: calc(100% - 42%) !important;
            margin-top: calc(100% - 50%) !important;
          }
        `
      }
       ${
         currentPage === 'clubpage' &&
         css`
           @media (min-device-width: 1374px) and (max-device-width: 1600px) {
             margin-left: calc(100% - 35%) !important;
             margin-top: calc(100% - 65%) !important;
           }
           @media (min-device-width: 1200px) and (max-device-width: 1373px) {
             margin-left: calc(100% - 35%) !important;
             margin-top: calc(100% - 37.5%);
           }
           @media (min-device-width: 1024px) and (max-device-width: 1196px) {
             margin-left: calc(100% - 35%) !important;
             margin-top: calc(100% - 37.5%);
           }
           @media (min-device-width: 821px) and (max-device-width: 1023px) {
             margin-left: calc(100% - 42.5%) !important;
             margin-top: calc(100% - 45%);
           }
           @media (min-device-width: 810px) and (max-device-width: 820px) {
             margin-left: calc(100% - 42.5%) !important;
             margin-top: calc(100% - 37.5%);
           }
           @media (min-device-width: 750px) and (max-device-width: 769px) {
             margin-left: calc(100% - 45%) !important;
             margin-top: calc(100% - 40%);
           }
           @media (min-device-width: 601px) and (max-device-width: 749px) {
             margin-left: calc(100% - 55%) !important;
             margin-top: calc(100% - 30%);
           }
           ${breakpoints.mm_xs_s} {
             margin-left: calc(100% - 92%) !important;
             margin-top: calc(100% + 18%);
           }
         `
       }
      ${
        currentPage === 'teampage' &&
        css`
          @media (min-device-width: 1374px) and (max-device-width: 1600px) {
            margin-left: calc(100% - 35%) !important;
            margin-top: calc(100% - 75%) !important;
          }
          @media (min-device-width: 1024px) and (max-device-width: 1196px) {
            margin-left: calc(100% - 35%) !important;
            margin-top: calc(100% - 50%);
          }
          @media (min-device-width: 821px) and (max-device-width: 1023px) {
            margin-left: calc(100% - 42.5%) !important;
            margin-top: calc(100% - 45%);
          }
          @media (min-device-width: 810px) and (max-device-width: 820px) {
            margin-left: calc(100% - 42.5%) !important;
            margin-top: calc(100% - 37.5%);
          }
          @media (min-device-width: 750px) and (max-device-width: 769px) {
            margin-left: calc(100% - 45%) !important;
            margin-top: calc(100% - 40%);
          }
          @media (min-device-width: 670px) and (max-device-width: 749px) {
            margin-left: calc(100% - 50%) !important;
            margin-top: calc(100% - 27.5%);
          }
          @media (min-device-width: 601px) and (max-device-width: 669px) {
            margin-left: calc(100% - 55%) !important;
            margin-top: calc(100% - 30%);
          }
          ${breakpoints.mm_xs_s} {
            margin-left: calc(100% - 92%) !important;
            margin-top: calc(100% + 18%);
          }
        `
      }

      ${
        scrollDirection === SCROLL_UP &&
        (isDesktop ? position > 370 : position > 636) &&
        css`
          margin-top: calc(100% - 88%) !important;
          ${divAnimation === false &&
          css`
            box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
            opacity: 75%;
            margin-top: calc(100% - 97%) !important;
            position: fixed;
          `}

          ${divAnimation === true &&
          css`
            position: fixed;
            margin-top: calc(100% - 97%) !important;
          `}

          ${isMobile &&
          css`
            margin-top: calc(100% - 98%) !important;
          `}

        ${isSmallMobile &&
          css`
            margin-top: 0 !important;
          `}
        `
      }
      ${
        scrollDirection === SCROLL_UP &&
        currentPage === 'clubpage' &&
        (isIpad ? position > 290 : position > 310) &&
        css`
          margin-top: calc(100% - 97%) !important;

          ${divAnimation === false &&
          css`
            box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
            opacity: 75%;
            margin-top: calc(100% - 97%);
            position: fixed;
          `}

          ${divAnimation === true &&
          css`
            position: fixed;
            margin-top: calc(100% - 97%) !important;
          `}
        `
      }
      ${
        scrollDirection === SCROLL_UP &&
        currentPage === 'teampage' &&
        (isIpad ? position > 290 : position > 310) &&
        css`
          margin-top: calc(-4.5%) !important;

          ${divAnimation === false &&
          css`
            box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
            opacity: 75%;
            margin-top: calc(-4.5%);
            position: fixed;
          `}

          ${divAnimation === true &&
          css`
            position: fixed;
            margin-top: calc(-4.5%) !important;
          `}
        `
      }
      ${
        scrollDirection === SCROLL_UP &&
        currentPage === 'homepage' &&
        (isIpad ? position > 370 : position > 540) &&
        css`
          margin-top: calc(-2.5%) !important;

          ${divAnimation === false &&
          css`
            box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
            opacity: 75%;
            margin-top: calc(-2.5%) !important;
            position: fixed;
          `}

          ${divAnimation === true &&
          css`
            position: fixed;
            margin-top: calc(-2.5%) !important;
          `}
        `
      }
      ${
        scrollDirection === SCROLL_DOWN &&
        (isDesktop ? position > 370 : position > 636) &&
        css`
          margin-top: calc(100% - 88%) !important;
          ${divAnimation === false &&
          css`
            opacity: 75%;
            position: fixed;
          `}

          ${divAnimation === true &&
          css`
            position: fixed;
          `}

        ${isMobile &&
          css`
            margin-top: calc(100% - 98%) !important;
          `}
        ${isSmallMobile &&
          css`
            margin-top: 0 !important;
          `}
        `
      }
      ${
        scrollDirection === SCROLL_DOWN &&
        (isIpad ? position > 290 : position > 310) &&
        css`
          margin-top: calc(100% - 80%) !important;

          ${divAnimation === false &&
          css`
            opacity: 75%;
            position: fixed;
          `}

          ${divAnimation === true &&
          css`
            position: fixed;
          `}
        `
      }
      ${
        scrollDirection === SCROLL_DOWN &&
        currentPage === 'homepage' &&
        (isIpad ? position > 370 : position > 540) &&
        css`
          margin-top: calc(10%) !important;

          ${divAnimation === false &&
          css`
            opacity: 75%;
            position: fixed;
          `}

          ${divAnimation === true &&
          css`
            position: fixed;
          `}
        `
      }
      ${
        currentPage === 'teampage' &&
        scrollDirection === SCROLL_DOWN &&
        (isIpad ? position > 290 : position > 310) &&
        css`
          margin-top: calc(100% - 97.5%) !important;

          ${divAnimation === false &&
          css`
            opacity: 75%;
            position: fixed;
          `}

          ${divAnimation === true &&
          css`
            position: fixed;
          `}
        `
      }
      ${
        currentPage === 'clubpage' &&
        scrollDirection === SCROLL_DOWN &&
        (isIpad ? position > 290 : position > 310) &&
        css`
          margin-top: calc(100% - 90%) !important;

          ${divAnimation === false &&
          css`
            opacity: 75%;
            position: fixed;
          `}

          ${divAnimation === true &&
          css`
            position: fixed;
          `}
        `
      }
      }

       ${breakpoints.m} {
        margin-left: calc(100% - 36%) !important;
        position: absolute;
        background-color: white;
        background-image: none !important;
        margin-top: 392px !important;
      }
    `,
    quick: (closeani, currentPage) => css`
      max-width: 311px !important;
      height: 0px;
      background-color: ${colors.white};
      border: 1px ${colors.lightGrey} solid;
      border-radius: 0 0 8px 8px !important;
      display: none;
      opacity: 0;
      border-top: 0;

      ${breakpoints.xl} {
        border-radius: 0 0 8px 8px !important;
      }
      ${closeani &&
      css`
        height: auto;
        animation-name: opacitytest;
        animation-duration: 1s;
        margin: auto;
        display: grid;
        animation-fill-mode: forwards;
        -webkit-animation-fill-mode: forwards;
      `}
      @keyframes opacitytest {
        50% {
          transition-property: opacity;
          transition: 0.5s;
          transition-timing-function: ease-in-out;

          opacity: 0.5;
        }
        100% {
          opacity: 1;
        }
      }
      ${!closeani &&
      css`
        transition-property: height;
        transition-duration: 0.1s;
        transition-timing-function: ease-in-out;
      `}
    `,
    sectionStyle: css`
      font-size: 18px;
      color: ${colors.navy};
    `,
    closeIcon: closeani => css`
      cursor: pointer;
      margin: auto;
      svg {
        color: red;
        width: 25px;
        height: 20px;
        margin: 5px auto 0;
        position: relative;
        z-index: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow-y: hidden;

        ${closeani === true &&
        css`
          animation-name: closeicon;
          animation-duration: 0.7s;
          margin: auto;

          @keyframes closeicon {
            50% {
              transition-property: width;
              transition: 0.5s;
              transition-timing-function: ease-in-out;

              width: 5px;
            }
            100% {
              width: 20px;
            }
          }
        `}
      }
    `,
    quickLinkList: css`
      padding: 10px 0;
    `,
    listData: statsHidden => css`
      align-items: center;
      display: grid;
      grid-template-columns: 6% auto;
      grid-template-rows: 95% 5%;
      font-size: 18px;
      color: ${colors.navy};
      width: 263px;
      padding-left: 15px;
      height: 48px;
      margin-top: -2px;

      &:hover {
        border: 0px;
        background-color: ${colors.lightGrey};
        border-radius: 100px;
      }

      ${statsHidden === true &&
      css`
        &:nth-child(2) {
          height: 20px;
          display: none;
        }
      `}
    `,
    quickLink: css`
    &:focus-visible{
        border-bottom: 2px solid ${colors.border_black};
        outline: none;
        background-color: ${colors.skip_yellow};
      }`,
    quickAnimate: css`
      padding-left: 23px;
    `,
    redlineSVG: css`
      display: grid;
      grid-template-columns: 7% auto;
    `,
    svgStyle: css`
      margin-top: 5px;
    `,
    onThisPage: divAnimation => css`
      font-size: 20px;
      font-weight: 700;
      color: ${colors.navy};
      border: 1px ${colors.lightGrey} solid;
      border-bottom: 0 grey solid;
      background-color: ${colors.lightGrey};
      display: grid;
      grid-template-columns: 65% 35%;
      grid-template-rows: 99% 1%;
      padding-left: 25px;
      height: 60px;
      border-radius: 8px !important;
      width: 311px;
      ${divAnimation === true &&
      css`
        border-radius: 8px 8px 0 0 !important;
        background-color: ${colors.white};
      `}
      &:focus-visible{
        border: 2px solid ${colors.border_black};
        outline: 2px solid ${colors.skip_yellow};
      }
    `,
    pageHeading: css`
      margin-bottom: 10px;
      padding-top: 18px;
    `,
  };
};
